'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.setViewTime = setViewTime;
exports.getArticleDetail = getArticleDetail;
var GET_ARTICLE_DETAIL = 'article/GET_ARTICLE_DETAIL';
var GET_ARTICLE_DETAIL_SUCCESS = 'article/GET_ARTICLE_DETAIL_SUCCESS';
var GET_ARTICLE_DETAIL_FAIL = 'article/GET_ARTICLE_DETAIL_FAIL';

var SET_VIEW_TIME = 'article/SET_VIEW_TIME';
var SET_VIEW_TIME_SUCCESS = 'article/SET_VIEW_TIME_SUCCESS';
var SET_VIEW_TIME_FAIL = 'article/SET_VIEW_TIME_FAIL';

var initialState = {
    details: {},
    loading: true
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case GET_ARTICLE_DETAIL:
            return _extends({}, state, {
                details: {},
                loading: true
            });
        case GET_ARTICLE_DETAIL_SUCCESS:
            if (!action.result.data.success) {
                return state;
            }
            return _extends({}, state, {
                loading: false,
                details: action.result.data.data
            });
        default:
            return state;
    }
}

function setViewTime(id) {
    var params = {
        courseId: id
    };
    return {
        types: [SET_VIEW_TIME, SET_VIEW_TIME_SUCCESS, SET_VIEW_TIME_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/course/view_times', params);
            }

            return promise;
        }()
    };
}

function getArticleDetail(id) {
    return {
        types: [GET_ARTICLE_DETAIL, GET_ARTICLE_DETAIL_SUCCESS, GET_ARTICLE_DETAIL_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/bp/course/detail/' + id);
            }

            return promise;
        }()
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/article/article.js
// module id = 495
// module chunks = 0